import {
    Box,
    Container,
    Typography,
    Button,
    Grid,
    useTheme,
    useMediaQuery,
  } from "@mui/material";
  import React from "react";
  import { useTranslation } from "react-i18next";
  import PTTranslate from "../../../../common/components/ui/PTTranslate";
    
  const AboutSection = () => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
    // Handle opening URL in new tab
    const handleReadMoreClick = () => {
      window.open('https://www.portnet.ma/qui-sommes-nous-', '_blank', 'noopener,noreferrer');
    };
        
    return (
      <Box
        id="about-section"
        sx={{
          py: { xs: 6, md: 10 },
          bgcolor: '#1a1f45', // Dark blue background
          width: '100%',
          color: '#fff', // White text
          scrollMarginTop: { xs: '60px', sm: '70px', md: '80px' }, // Added scroll margin to account for fixed navbar
        }}
      >
        <Container maxWidth="lg">
          {/* Section Header - Using similar styling to HowItWorks */}
          <Box sx={{ mb: { xs: 4, md: 6 } }}>
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
                fontWeight: 700,
                mb: 1.5,
                color: '#fff',
                textAlign: 'left',
                lineHeight: 1.2,
              }}
            >
              <PTTranslate tk="about.title" />
            </Typography>
          </Box>
          
          {/* Using Grid to match HowItWorks layout */}
          <Grid container spacing={{ xs: 4, md: 6 }}>
            {/* Making this take full width of the container similar to HowItWorks */}
            <Grid item xs={12}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: '1rem', sm: '1.1rem', md: '1.25rem' },
                  lineHeight: 1.7,
                  mb: { xs: 4, md: 5 },
                  color: 'rgba(255, 255, 255, 0.9)',
                  width: { xs: '100%', md: '90%' },
                }}
              >
                <PTTranslate tk="about.description" />
              </Typography>
              
              <Button
                variant="outlined"
                onClick={handleReadMoreClick}
                sx={{
                  color: '#fff',
                  borderColor: '#fff',
                  borderRadius: '7px', // Matching the same radius as HowItWorks
                  px: { xs: 4, md: 5 },
                  py: { xs: 1.2, md: 1.5 },
                  textTransform: 'none',
                  fontWeight: 600,
                  fontSize: { xs: '0.9rem', md: '1rem' },
                  '&:hover': {
                    borderColor: '#fff',
                    bgcolor: 'rgba(255, 255, 255, 0.1)',
                  },
                }}
              >
                <PTTranslate tk="about.readMore" />
              </Button>
            </Grid>
          </Grid>
        </Container>
      </Box>
    );
  };
    
  export default AboutSection;